// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  requestId: __t.u128(),
  versionId: __t.u64(),
  filename: __t.string(),
  relativePath: __t.string(),
  isPrimary: __t.bool(),
  sizeBytes: __t.u64(),
  hash: __t.string(),
  contentType: __t.string(),
  blobPath: __t.string(),
  chunkSize: __t.u32(),
  chunkCount: __t.u32(),
};
